import { createRef, useState } from "react"
import { Detail } from ".."
import { ReportFolioDetailContext } from "../context"
import { ItemMenu } from "../../../../../../../components/baseMenu"
import { getArea, getDepartments, getStore } from "../../../../../../../utils/methods/geServiceWithItemsFormat"
import { ItemsEdit } from "./types"
import { Priority } from "../../../typing"
import { useTranslation } from "react-i18next"
import { Roles, Types } from "../../../../../../../utils/enums"
import { Item, ObjectGeneric, Table } from "../../../../../../../utils/types/generals"
import { reportFolioServices, userServiceFetch } from "../../../../../../../utils/constants/callService"
import { useParams, useNavigate, useLocation } from "react-router"
import { getLocalStorage, LocaleNameType } from "../../../../../../../utils/crud/crypt"
import { ResendRef } from "../../../../../../../components/resend/types"
import { ModalState } from "../../../../../../questionnaire/pages/detail/typing/types"
import { SubmitResendReport } from "../../../../../../calendar/pages/main/types"
import { reportFolioDetailMenuType } from "../enums"
import { FolioType } from "../../../utils/enums/folioType"

const ReportFolioDetailProvider = () => {
    const location = useLocation()
    const ref = createRef<ResendRef>()
    const state = getLocalStorage(LocaleNameType.STATE)
    const { t } = useTranslation()
    const { id } = useParams()
    const userId = state?.id
    const roleId = state?.role
    const [modal, setModal] = useState<ModalState>({ open: false, title: '', description: '' })
    const [errorsResend, setErrorsResend] = useState<string[]>([])
    const [userAssigned, setUserAssigned] = useState<Item[]>([])
    const [userTracking, setUserTracking] = useState<string[]>([])
    const [typeFolio, setTypeFolio] = useState(FolioType.CORRECTIVE)
    const [loadings, setLoadings] = useState({
        update: false,
        next: false,
        resend: false
    })
    const navigate = useNavigate()
    const [loadingUsers, setLoadingUsers] = useState(false)
    const [changeReportFolio, setChangeReportFolio] = useState(false)
    const [tableData, setTableData] = useState<Table>({ column: [], row: [] })
    const [userSelected, setUserSelected] = useState<number | null>()
    const [apiBusy, setApiBusy] = useState(false)
    const [modalReassign, setModalReassign] = useState(false)
    const [optionSelected, setOptionSelected] = useState<ItemMenu | null>(null)
    const [snackbar, setSnackbar] = useState({
        message: '',
        open: false,
        type: Types.ERROR,
    })
    const isUserAssigned = userAssigned.some(item => item.value == userId)
    const [statusAttencion, setStatusAttention] = useState<{
        statusAttentionId: number | null
        userAttendingId: number | null
    }>({ statusAttentionId: null, userAttendingId: null })
    const [creatorUser, setCreatorUser] = useState<{
        user?: string;
        date?: string;
        id?: string | number | null;
    }
    >({})
    const [items, setItems] = useState<ItemsEdit>({
        priority: [
            {
                label: t('general.priority.suggestion'),
                value: Priority.SUGGESTION,
                id: Priority.SUGGESTION.toString(),
            },
            {
                label: t('general.priority.medium'),
                value: Priority.MEDIUM,
                id: Priority.MEDIUM.toString(),
            },
            {
                label: t('general.priority.urgent'),
                value: Priority.URGENT,
                id: Priority.URGENT.toString(),
            },
        ],
    })

    const selectOption = (item: ItemMenu | null) => {
        const option = item?.value
        if (option == reportFolioDetailMenuType.RESEND_REPORT) {
            setModal(prev => ({ ...prev, open: true }))
            setOptionSelected(item)
            return
        }
        if (option == reportFolioDetailMenuType.REASIGN_USER) {
            const stateNavigation = {
                state: {
                    ...location.state,
                    replaceRoutes: {
                        ...location?.state?.replaceRoutes ?? {},
                        folio_detail: {
                            search: location?.search,
                            state: location?.state
                        }
                    }
                }
            }
            navigate(`/dashboard/report-folio/dashboard/detail/reassign-user/${id}`, stateNavigation)
            return
        }
        if (option == reportFolioDetailMenuType.EDIT) {
            navigate(`/dashboard/report-folio/dashboard/${typeFolio == FolioType.CORRECTIVE ? 'correctivo':'preventivo'}/${id}`)
            return
        }
        setOptionSelected(item)
    }

    const getAllAreas = async () => {
        const response = await getArea()
        if (response?.length) {
            setItems(prev => ({ ...prev, area: response }))
        }
    }

    const submitResendReport = ({ id, data, }: SubmitResendReport) => {
        setLoadings((prev) => ({ ...prev, resend: true, }))
        const emails = data?.externalEmails
            ?.split(',')
            ?.filter((item: string) => !!item)

        let body: ObjectGeneric = {
            sendCreatedBy: !!data?.sendCreatedBy,
            sendDptManagers: !!data?.sendUserAssign,
            sendDirectParent: !!data?.sendManageStore,
        }

        if (!!emails?.length) body.externalEmails = emails
        const clearData = ref.current?.clearData
        reportFolioServices
            .resendReportFolio({ id: id, body })
            .then((response) => {
                if (!response?.errors) {
                    if (clearData) { clearData() }
                    closeModal()
                    setSnackbar((prev) => ({
                        ...prev,
                        open: true,
                        message: t('reportFolio.snackbar.sendReport.success'),
                        type: Types.SUCCESS,
                    }))
                } else {
                    setSnackbar((prev) => ({
                        ...prev,
                        open: true,
                        message: t('reportFolio.snackbar.sendReport.ERR_NOT_FOUND'),
                        type: Types.ERROR,
                    }))
                }
            })
            .finally(() => { setLoadings((prev) => ({ ...prev, resend: false, })) })
    }

    const getAllDepartments = async () => {
        const response = await getDepartments()
        if (response?.length) {
            setItems(prev => ({ ...prev, department: response }))
        }
    }
    const getUsers = async () => {
        const data = await userServiceFetch.usersFolio(Number(id))

        if (data?.length) {
            setItems(prev => ({
                ...prev, users: data?.map((item: any) => (({
                    id: item.id,
                    value: item.id,
                    label: `${item.firstName ?? ''} ${item.lastName ?? ''} - ${item?.curp}`
                })))
            }))
        }
    }

    const reassignUser = () => {
        getUsers()
        setUserSelected(null)
        setApiBusy(false)
        setModalReassign(true)
    }
    const getAllUnits = async () => {
        const response = await getStore()
        if (response?.items?.length) {
            setItems(prev => ({ ...prev, units: response?.items }))
        }
    }

    const getCancelReasons = async () => {
        const response = await reportFolioServices.getCancelReasonList()
        if (!response?.errors) {
            setItems(prev => ({
                ...prev, cancel: response?.map(reason => ({
                    id: reason.id?.toString(),
                    label: reason.description ?? '',
                    value: reason.id || '',
                    requestText: !!reason.requestText
                }))
            }))
        }
    }
    const getReassignReasons = async () => {
        const response = await reportFolioServices.getReassignReasonList()
        if (!response?.errors) {
            setItems(prev => ({
                ...prev, reassign: response?.map(reason => ({
                    id: reason.id?.toString(),
                    label: reason.description ?? '',
                    value: reason.id || '',
                    requestText: !!reason.requestText
                }))
            }))
        }
    }
    const callEditEndpoint = () => {
        if (!items.area?.length) { getAllAreas() }
        if (!items.department?.length) { getAllDepartments() }
        if (!items.units?.length) { getAllUnits() }
    }
    const callReassignAreaAndDepartmentEndpoint = () => {
        if (!items.area?.length) { getAllAreas() }
        if (!items.department?.length) { getAllDepartments() }
        if (!items.reassign?.length && (roleId != Roles.ADMIN && creatorUser?.id != userId)) { getReassignReasons() }
    }

    const callReassignUserEndpoint = () => {
        if (!items.users?.length) { getUsers() }
    }

    const callCancelEndpoints = () => {
        if (!items.cancel?.length) { getCancelReasons() }
    }

    const closeSnackbar = () => {
        setSnackbar(prev => ({ ...prev, open: false }))
    }
    const closeModal = () => {
        setModal(() => ({
            description: '',
            open: false,
            title: '',
            cancel: undefined,
            cancelText: undefined,
            confirm: undefined,
            confirmText: undefined,
            icon: undefined
        }))
    }

    const unsubscribeUserFromTheFolio = () => {
        if (isUserAssigned) {
            reportFolioServices.ussubscribeUserFromTheFolio({ id: String(id) })
        }
    }

    const handleExit = () => {
        //unsubscribeUserFromTheFolio()
        navigate('/dashboard/report-folio/dashboard')
        setChangeReportFolio(false)
        closeSnackbar()
    }

    const confirmReturn = () => {
        setModal(() => ({
            description: '',
            open: true,
            title: t('reportFolio.modal.return'),
            confirm: () => {
                handleExit()
            },
            cancel: closeModal
        }))
    }

    return (
        <ReportFolioDetailContext.Provider value={{
            ref,
            items,
            setTypeFolio,
            modal,
            apiBusy,
            snackbar,
            loadings,
            tableData,
            creatorUser,
            userTracking,
            errorsResend,
            loadingUsers,
            userSelected,
            userAssigned,
            modalReassign,
            optionSelected,
            isUserAssigned,
            statusAttencion,
            changeReportFolio,
            setModal,
            handleExit,
            setApiBusy,
            closeModal,
            setSnackbar,
            setUserTracking,
            setLoadings,
            setTableData,
            selectOption,
            reassignUser,
            closeSnackbar,
            confirmReturn,
            setCreatorUser,
            setErrorsResend,
            setLoadingUsers,
            setUserAssigned,
            setUserSelected,
            setModalReassign,
            callEditEndpoint,
            submitResendReport,
            setStatusAttention,
            callCancelEndpoints,
            setChangeReportFolio,
            callReassignUserEndpoint,
            unsubscribeUserFromTheFolio,
            callReassignAreaAndDepartmentEndpoint,
        }}><Detail /></ReportFolioDetailContext.Provider>
    )
}

export { ReportFolioDetailProvider }